export const conditionRoutes = {
	conditionIndex: '/conditions'
} as const
